/* show password reset form after submission */
if (window.location.hash) {
  var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
  //alert (hash);
  // hash found
  if (hash == 'recover') {
    $('#login').hide();
    $('#recover').show();
  }
}
/* end - show password form after submission */

/*
  Right align dropdowns which might fall out of the screen.
*/
function calculateDropdownsPosition(){
  $('.js-nav-new > ul > li').each(function(){
    var $this = $(this);
    $this.removeClass('right-aligned');

    if (!$this.find('.nav__dropdown').length) {
      return;
    }

    var $dropdown = $this.find('.nav__dropdown');
    var dd_left_position = $dropdown.offset().left;
    var dd_width = $dropdown.find('.shell-small').outerWidth();

    // save the width in data since it might change
    if ( $this.data('ddwidth') == undefined ) {
      $this.data('ddwidth', dd_width);
    }

    dd_width = $this.data('ddwidth');

    var dd_right_position = dd_left_position+dd_width;

    var window_size = $(window).width();

    if ( dd_right_position > window_size) {
      $this.addClass('right-aligned');
    }
  })
}

(function ($) {
  calculateDropdownsPosition();

  $('.header ul[data-level="2"]').each(function () {
    var levelTwo = $(this);

    if (levelTwo.find('ul[data-level="3"]').length > 1) {
      levelTwo.addClass('has-multi-columns');
    }
  });

  var lastScrollTop = 0;

  $(window).scroll(function (event) {
      var scroll_2 = $(window).scrollTop();
      console.log('scroll / '+ scroll_2);
      if (scroll_2 === 0) {
        $('.header-wrapper').add($('.main-wrapper')).addClass('initmenuCero');
      }else{
        $('.header-wrapper').add($('.main-wrapper')).removeClass('initmenuCero');
      }
  });

  $(window)
    .on('scroll', function(event){
      var st = $(this).scrollTop();

      

      if (st >= 100) {
        if (st > lastScrollTop){
          $('.header-wrapper').add($('.main-wrapper')).addClass('is-condensed');
          $('.header-wrapper').add($('.main-wrapper')).removeClass('initmenu');
        } else {
          $('.header-wrapper').add($('.main-wrapper')).removeClass('is-condensed');
          $('.header-wrapper').add($('.main-wrapper')).addClass('initmenu');
        }

        lastScrollTop = st;
      }
    })
    .on('load', function () {
      if ($(window).scrollTop() > 0) {
        $('.header-wrapper').add($('.main-wrapper')).addClass('is-condensed');
      } else {
        $('.header-wrapper').add($('.main-wrapper')).removeClass('is-condensed');
      }
    });

  $(document).on('click', '.js-nav-trigger', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $('.nav-mobile').toggleClass('is-active');
  });

  $(document).on('click', '.nav-mobile .menu__item--has-dropdown > a:not(.clicked)', function (e) {
    e.preventDefault();

    var $this = $(this);

    $this
      .addClass('is-active clicked')
      .next()
      .slideToggle()
      .parent()
      .siblings()
      .find('a')
      .removeClass('is-active clicked')
      .next()
      .slideUp();
  });

  $('.js-predictive-search').each(function (index, element) {
    var $this = $(this);
    var $form = $this.closest('form');

    setTimeout(function () {
      $this.attr('readonly', false);
    }, 500);

    $form.on('focusin', function () {
      if ($this.val().length !== 0) {
        // $form.find('.js-search-results').addClass('is-active');
      }
    });

    $form.on('focusout', function () {
      // $form.find('.js-search-results').removeClass('is-active');
    });
  });

  // Fix bug search
  
  
  function showFocusSearch() {
    jQuery('.form-search.form-search--blog input#q-1').focus();
  }  
  function showFocusSearchHeader() {
    jQuery('.header-new .form-search input#q-1').focus();
    jQuery('.form-search.form-search--blog input#q-1').blur();
  }  

  var intervalSearchBlog = '';
  var intervalSearchHeader = '';

  
  
  $('.js-predictive-search-blog').each(function (index, element) {
    var $this = $(this);
    var $form = $this.closest('form');

    setTimeout(function () {
      $this.attr('readonly', false);
    }, 500);

    $form.on('focusin', function () {
      if ($this.val().length !== 0) {
        // $form.find('.js-search-results-blog').addClass('is-active');
      }
    });

    $form.on('focusout', function () {
      // $form.find('.js-search-results-blog').removeClass('is-active');
    });
  });

  $('.js-predictive-search').on('input', function (e) {
    console.log('.js-predictive-search2');
    var $this = $(this);
    console.log($this);
    var searchTerm = e.target.value.toLowerCase();
    var $form = $(this).closest('form');
    var $resultsDropdown = $form.find('.js-search-results');

    $resultsDropdown.removeClass('is-active').empty();

    // When the search lives inside a blog landing page (Recipes or Guides),
    // restrict the predictive results to articles only — no products, pages,
    // or collections. The header search continues to include everything.
    var isBlogSearch = $form.closest('.section_search__blog').length > 0
                    || $this.is('[data-search-blog]');
    var resourceTypes = isBlogSearch ? 'article' : 'product,page,article,collection';

    $.getJSON('/search/suggest.json', {
      q: searchTerm,
      resources: {
        type: resourceTypes,
        limit: 5,
      },
    }).done(function (response) {
      $resultsDropdown.removeClass('is-active').empty();
      let hiddenCollections = document.querySelector('#hidden-collections');
      // Guard each suggestion array — when the request restricts resources
      // (e.g. blog landing requests `type: 'article'` only), the response
      // omits the other keys entirely. Without the `|| []` fallback,
      // `.length` on undefined throws and aborts the rest of the handler
      // (including the articles branch). That's how restricting the blog
      // search broke ALL recommendations on the Guides landing.
      var productSuggestions = response.resources.results.products || [];
      var rawCollections = response.resources.results.collections || [];

      if (hiddenCollections) {
        hiddenCollections = hiddenCollections.innerHTML.split(',');
        var collectionSuggestions = rawCollections.filter(object => {
          return !hiddenCollections.some(element => object.handle.includes(element.replace('\n', '')));
        });
      } else {
        var collectionSuggestions = rawCollections;
      }

      var pageSuggestions = response.resources.results.pages || [];
      var articleSuggestions = response.resources.results.articles || [];

      var htmlMarkup = '';

      if (productSuggestions.length > 0) {
        htmlMarkup += '<h5>Products</h5><ul>';

        $.each(productSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup +=
            '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6><p>' + Shopify.formatMoney(element.price) + '</p></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (collectionSuggestions.length > 0) {
        htmlMarkup += '<h5>Categories</h5><ul>';

        $.each(collectionSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (pageSuggestions.length > 0) {
        htmlMarkup += '<h5>Pages</h5><ul>';

        $.each(pageSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (articleSuggestions.length > 0) {
        htmlMarkup += '<h5>Blog Posts</h5><ul>';

        $.each(articleSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (htmlMarkup !== '') {
        setInterval(showFocusSearchHeader, 1000);
        $resultsDropdown.append(htmlMarkup);
        $resultsDropdown.addClass('is-active');
      }
    });
  });

  // jQuery('body').on('click', 'div#fc_frame', function() {
  //   console.log('click chat2');
  //   clearInterval(intervalSearchHeader);
  // });

  $('.js-predictive-search-blog').on('input', function (e) {
    console.log('.js-predictive-search-blog1');
    var $this = $(this);
    var searchTerm = e.target.value.toLowerCase();
    var $form = $(this).closest('form');
    var $resultsDropdown = $form.find('.js-search-results-blog');

    $resultsDropdown.removeClass('is-active').empty();

    $.getJSON('/search/suggest.json', {
      q: searchTerm,
      resources: {
        type: 'article',
        limit: 5,
      },
    }).done(function (response) {
      $resultsDropdown.removeClass('is-active').empty();

      var articleSuggestions = response.resources.results.articles;

      var htmlMarkup = '';

      if (articleSuggestions.length > 0) {
        htmlMarkup += '<h5>Articles</h5><ul>';

        $.each(articleSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (htmlMarkup !== '') {
        console.log('htmlMarkup');
        setInterval(showFocusSearch, 1000);
        $resultsDropdown.append(htmlMarkup);
        $resultsDropdown.addClass('is-active');
      }
    });
  });

  $(document).ready(function () {
    // Handle clicks on the document
    $(document).click(function (event) {
        console.log('Click event detected');
        // If clicking outside the blog search input
        if (!$(event.target).is('.form-search.form-search--blog input#q-1')) {
            console.log('Clicked outside blog search input');
            clearInterval(intervalSearchBlog);
            $('.form-search.form-search--blog input#q-1').blur();
            jQuery('.search__dropdown.js-search-results-blog').removeClass('is-active');
        } else {
            // Ensure blog search input remains enabled
            $(".header-new .form-search input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }
        // If clicking inside the blog search input
        if ($(event.target).is('.form-search.form-search--blog input#q-1')) {
            setInterval(showFocusSearch, 1000);
        }
    });
    // Handle clicks specifically on header search input
    $(document).click(function (event) {
        if ($(event.target).is('.header-new .form-search input#q-1')) {
            console.log('Clicked inside header search input');
            clearInterval(intervalSearchBlog);
            $(".form-search.form-search--blog input#q-1").prop('disabled', false);
            $(".header-new .form-search input#q-1").prop('disabled', false);
        } else {
            console.log('Clicked outside header search input');
            $(".form-search.form-search--blog input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }
    });
    // Handle click on header search input to maintain focus intervals
    jQuery('body').on('click', '.header-new .form-search input#q-1', function () {
        console.log('Header search input clicked');
        intervalSearchBlog = setInterval(showFocusSearch, 10000);
        intervalSearchHeader = setInterval(showFocusSearchHeader, 10000);
    });
    // Handle blur event on header search input
    jQuery('.header-new .form-search input#q-1').on('blur', function () {
        console.log('Header search input lost focus');
        clearInterval(intervalSearchBlog);
        clearInterval(intervalSearchHeader);
        // Ensure the input remains enabled
        setTimeout(() => {
            $(".header-new .form-search input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }, 1000);
    });
    // Global safeguard to ensure the search inputs are never disabled
    setInterval(() => {
        $(".header-new .form-search input#q-1").prop('disabled', false);
        $(".form-search.form-search--blog input#q-1").prop('disabled', false);
    }, 1000);
});
  

  $(document).on('click', '#theme-ajax-cart button[type="submit"], #theme-ajax-cart a', function (e) {
    e.preventDefault();
    //HACK: this script is redirecting to the cart on any ajax cart change, which we don't want
    //ex: when clicking on x to close cart, we shouldn't be redirected to the cart page
    if (e.target.closest('button') && e.target.closest('button').getAttribute('aria-label') === 'close') {
      return;
    }
    var $this = $(this);

    if ($this.hasClass('ajax-cart__button')) {
      $this.closest('form').trigger('submit');

      return;
    }

    window.location.href = $this.attr('href');
  });

  $(window).on('load resize orientationchange', function () {
    const $header = $('.header-wrapper');
    const headerHeight = $header.outerHeight();

    $('.main-wrapper').css('margin-top', headerHeight);
    calculateDropdownsPosition();
  });

  $(window).on('load', function () {
    const $window = $(this);

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('shopify-section-header-megamenu');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // $window.trigger('resize');
        } else if (mutation.type === 'attributes') {
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    chartModalPopup();
  });

  function stickyNavigation($navigation, $mainContent, activeClass) {
    var lastScrollTop = 0;
    var $win = $(window);
    var currentCondition;

    $win
      .on('scroll', function(event){
        var st = $(this).scrollTop();
        currentCondition = st > lastScrollTop;

        updateStickyNav($navigation, $mainContent, activeClass, currentCondition)

        lastScrollTop = st;
      })
      .on('load', function () {
        currentCondition = $win.scrollTop() > 0;

        updateStickyNav($navigation, $mainContent, activeClass, currentCondition)
      });
  }

  function updateStickyNav($nav, $main, myClass, condition) {
    condition ? $nav.add($main).addClass(myClass) : $nav.add($main).removeClass(myClass)
  }

  function chartModalPopup() {
    // Get the modal
    const modal = document.querySelector('[js-chart-modal="modal"]');
    if(modal) {
      // Get the button that opens the modal
      const btn = document.querySelectorAll('[js-chart-modal="open"]');

      // Get the <span> element that closes the modal
      const span = document.querySelector('[js-chart-modal="close"]');

      // When the user clicks the button, open the modal
      btn.forEach(el => {
        el.onclick = function(event) {
          event.preventDefault();

          modal.style.display = "block";
        }
      })
      // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    }
  }

  $('.newsletter-success').on('click', function() {
    $(this).addClass('hidden');
  });
})(jQuery);



const headerNew = document.querySelector('.header-new');

/**
 * Trigger when banner is added to the page
 *
 * @return {Void}
 */
var observer = new WebKitMutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes[0]) {
      if (mutation.addedNodes[0].id === 'smartbar-app') {
        const wrapper = document.querySelector('.smartbar-wrapper');

        const smartbarObserver = new WebKitMutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.addedNodes[0]) {
              if (mutation.addedNodes[0].className === 'smartbar-barlist') {
                const barlist = document.querySelector('.smartbar-barlist');
                const bar = barlist.querySelector('.smartbar-bar');
                const close = document.querySelector('.smartbar-bar__close');
                const headerTopGap = bar.offsetHeight;
                headerNew.classList.add('banner-active');

                /**
                 * Update header
                 *
                 * @return {Void}
                 */
                const updateHeader = () => {
                  if (window.scrollY < headerTopGap) {
                    const gap = headerTopGap - window.scrollY;
                    headerNew.style.top = gap + 'px';
                  } else {
                    headerNew.style.removeProperty('top');
                  }
                }

                // updateHeader();

                window.addEventListener('scroll', (event) => {
                  if (headerNew.classList.contains('banner-active')) {
                    updateHeader()
                  }
                });

                /**
                 * Close trigger
                 *
                 * @return {Void}
                 */
                function closeTrigger() {
                  headerNew.style.removeProperty('top');
                  headerNew.classList.remove('banner-active');
                }

                close.addEventListener('click', closeTrigger);
              }
            }
          })
        })

        smartbarObserver.observe(wrapper, {
          childList: true
        });
      }
    }
  })
});

const body = document.querySelector('body');

observer.observe(body, {
    childList: true
});



// Script for wholesale
jQuery('document').ready(function(){   

    
    function updatePrice() {
      if (jQuery(".product_form").hasClass("wholesaleb2b")) {
        var priceMax =  $('div#shopify-section-product .wholesaleb2b .whspriced span').text();
        console.log('ENCONTRO CLASS');
        console.log(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price').removeAttr('data-price-mutation-watcher');
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').removeClass('recharge-inner-most-price');
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').text(priceMax);
      }   
    }    
    const intervalupdatePrice = setInterval(updatePrice, 250);
    updatePrice();

    setTimeout(function() {
        let priceRetail = jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded  span.was-price>span, div#shopify-section-product span.was-price>span').text();
        var priceRetailDefault =  $('div#shopify-section-product .rtlpricedDefault').data('pricedevm');
        
        jQuery('div#shopify-section-product .rtlpricedDefault span').text(function() {let price = priceRetailDefault; return price % 1 === 0 ? '$' + price : '$' + price.toFixed(2);});
    
        
        
        if(priceRetail != ''){
          // if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced, div#shopify-section-product p.rtlpriced').length){
          //   jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product  p.rtlpriced>span').text(priceRetail);
          // }  
          if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced').length){
            jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span').text(priceRetail);
          }  
        }              
    }, 2000);  
  
    

   setTimeout(function() { 
     clearInterval(intervalupdatePrice);
   }, 25000);
});

$('span.quick_shop.button.action_button').on('click', function(){ 
  console.log('CLICK QUICK SHOP');
  setTimeout(function() { 
        let priceRetail = jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded  span.was-price>span, div#shopify-section-product span.was-price>span').text();
        if(priceRetail != ''){
          if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced, div#shopify-section-product p.rtlpriced').length){
            jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product  p.rtlpriced>span').text(priceRetail);
          }  
        }              
    }, 3000);  
})


$(document).on('change', '.single-option-selector', function() {
    const intervalupdatePrice = setInterval(updatePrice, 250);
    function updatePrice() {
      if (jQuery(".product_form").hasClass("wholesaleb2b")) {
        var priceMax =  $('div#shopify-section-product .wholesaleb2b .whspriced span').text();
        console.log('ENCONTRO CLASS');
        console.log(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price').removeAttr('data-price-mutation-watcher');
        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').removeClass('recharge-inner-most-price');


        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').text(priceMax);
        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price.recharge-inner-most-price').text(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice').removeAttr('data-price-mutation-watcher');
      }   
    }  
    updatePrice();
    setTimeout(function() { 
     clearInterval(intervalupdatePrice);
    }, 25000);
  
    const value = $(this).val();
    var term = "collections";
    var handleUrl = window.location.pathname;
    console.log(handleUrl);
    var incStr = handleUrl.includes(term);
  
    if(incStr){
      console.log('ENCONTRO COLLECTION');
      var handleUrl = jQuery('h3.quick-shop__title.js-product-title>a').attr('href');
      setTimeout(function() { 
        const $selectorVariant = $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded [data-variant-selector]').find('option:contains(' + value + ')');
        var valueSelect = $selectorVariant.val();

        console.log(window.location);
        var rulesVariants = '';
    
       // jQuery('.product-form-container .control.quantity-input-control input.quantity-input.quantity-element.input').val('0');
      
        $.ajax({
          url: ''+handleUrl+'.json',
          type: 'GET',
          dataType: 'json',
          success: function(data) {
            console.log(data);
            // if(data.product){
              let variantsProduct = data.product.variants
              console.log(data.product.variants); // Datos del producto
              for (let index = 0; index < variantsProduct.length; index++) {
                var rulesVariants = variantsProduct[index].quantity_rule.min;
                var retailPrice = variantsProduct[index].compare_at_price;
                var wholePrice = variantsProduct[index].price;
                var idVariants = variantsProduct[index].id;
                if(idVariants == valueSelect){
                  $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded span.quantityRulesMin, div#shopify-section-product span.quantityRulesMin').text(rulesVariants); 
                   $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product p.rtlpriced>span').text('$'+retailPrice);
                   $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.whspriced>span, div#shopify-section-product p.whspriced>span').text('$'+wholePrice);
                }          
              }
            // }
            
          },
          error: function(error) {
            console.log('Error:', error);
          }
        });
      }, 1500);
    }else{
      const $selectorVariant = $('[data-variant-selector]').find('option:contains(' + value + ')');
      var valueSelect = $selectorVariant.val();

      console.log(window.location);
      var rulesVariants = '';
  
     // jQuery('.product-form-container .control.quantity-input-control input.quantity-input.quantity-element.input').val('0');
    
      $.ajax({
        url: ''+handleUrl+'.json?fields=id,title,variants,metafields',
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          console.log(data);
          // if(data.product){
            let variantsProduct = data.product.variants

            console.log(data); // Datos del producto
            console.log(data.product.variants); // Datos del producto
            for (let index = 0; index < variantsProduct.length; index++) {
              console.log('METAFIELDS'+variantsProduct[index].metafields);
              var rulesVariants = variantsProduct[index].quantity_rule.min;
              var retailPrice = variantsProduct[index].compare_at_price;
              var wholePrice = variantsProduct[index].price;
              var idVariants = variantsProduct[index].id;
              var metafieldValue = variantsProduct[index].metafields && variantsProduct[index].metafields.custom && variantsProduct[index].metafields.custom.retail_price_variant_c;

             
              $('div#shopify-section-product p.rtlpriced2').each(function(){
                 var dataidVariant =  $(this).data('idvm');
                 var dataPriceVariant =  $(this).data('pricevm');
                 if(dataidVariant == idVariants){
                   console.log('IDVARIAN / '+dataidVariant);
                   $(this).find('span').text('$'+dataPriceVariant);
                 }                  
              });
              
              if(idVariants == valueSelect){
                 var dataPriceVariantC =  $('div#shopify-section-product p.rtlpriced2[data-idvm="'+idVariants+'"]').data('pricevm');
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded span.quantityRulesMin, div#shopify-section-product span.quantityRulesMin').text(rulesVariants); 
                 // $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product p.rtlpriced>span').text('$'+retailPrice);
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span').text('$'+retailPrice);
                 $('div#shopify-section-product p.rtlpriced>span').text(function() {
    let price = parseFloat(dataPriceVariantC); 
    return '$' + price.toFixed(2); 
});

                 // $('div#shopify-section-product p.rtlpriced>span').fadeIn();
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.whspriced>span, div#shopify-section-product p.whspriced>span').text('$'+wholePrice);
              }          
            }
          // }
          
        },
        error: function(error) {
          console.log('Error:', error);
        }
      });
    }
    
    
  
    setTimeout(function() { 
      // let priceCurrent = $('span.current_price>span').text();
      // if($('p.rtlpriced').length){
      //   $('p.whspriced>span').text('$'+wholePrice);
      // }  
       // $('p.whspriced>span').text('$'+wholePrice);
    }, 2000);
})


// Change product slider on variant change
let init_c = 0;
$(document).on('change', '.single-option-selector', function() {    
    console.log('CHANGE');
    const value = $(this).val();
    const $selectorVariant = $('[data-variant-selector]').find('option:contains(' + value + ')');
  
    // if ($selectorVariant && !$('.js-product-sliders').length) {
    if ($selectorVariant && $('body.product .js-product-sliders').length) {
      console.log('here 01');
      const imageId = $selectorVariant.data('media-id');
      console.log(imageId);
  
      if (imageId) {
        // const variantImageSlide = $('.product-gallery .product-gallery__main .flickity-slider').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        const variantImageSlide = $('.product-gallery .product-gallery__main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
  
        if (variantImageSlide) {
          const index = variantImageSlide.data('index');
          console.log(index);
          if( init_c != 0){
            $('.product-gallery .product-gallery__main').slick( "slickGoTo", [index]);
           // $('.product-gallery .product-gallery__main').trigger( "slideNow", [index]);
          }else{
            init_c = 1 ;
          }
          
        }
      }
  
      return;
    }
  
    if ($selectorVariant && !$('body.collection .js-product-sliders').length) {
      console.log('here 02');
      const imageId = $selectorVariant.data('media-id');
      console.log(imageId);
  
      if (imageId) {
        const variantImageSlide = $('.product-gallery .product-gallery__main .flickity-slider').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        // const variantImageSlide = $('.product-gallery .product-gallery__main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
  
        if (variantImageSlide) {
          const index = variantImageSlide.data('index');
          
          // $('.product-gallery .product-gallery__main').slick( "slickGoTo", [index]);
           $('.product-gallery .product-gallery__main').trigger( "slideNow", [index]);
        }
      }
  
      return;
    }
  
    if($('.has-filter-images').length){
      productSlidersFiltering()
    } else if($selectorVariant) {
      const imageId = $selectorVariant.data('media-id');
  
      if (imageId) {
        const variantImageSlide = $('.js-product-sliders-main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        const slideIndex = variantImageSlide.parents('.slick-slide').data('slick-index')
  
        if(variantImageSlide){
          slickObj = $('.js-product-sliders-main').slick('getSlick')
  
          slickObj.slickGoTo(slideIndex, true)
        }
      }
    }
})





function productSlidersFiltering(){
  let sku = findSku().toString()
  let hasFiltering = checkProductImages(sku)

  startImageFiltering('.js-product-sliders', hasFiltering, sku)
}

function findSku(){
  const $mainSelector = $('[data-variant-selector]');
  const selectedVariantVal = $mainSelector.val()
  const $selectedOption = $mainSelector.find(`option[value="${selectedVariantVal}"]`);

  return $selectedOption.data('sku')
}

function checkProductImages(sku){
  const $slider = $('.js-product-sliders-main')

  if(sku && $slider){
    const imagesAlts = window.mediaData[0].split(',').filter(Boolean)

    return imagesAlts.some(imageAlt => {
      const slideAltText = imageAlt.split('|')

      return slideAltText.indexOf(sku) > -1
    })
  } else {
    return false
  }
}

function startImageFiltering(className, hasFilterVariants, sku){
  const productSliders = $(className)

  productSliders.slick('slickUnfilter')

  if (hasFilterVariants) {
    const activeVariantFilter = `filter-${sku}`

    addFilterClasses(productSliders, sku)
    filterImages(productSliders, activeVariantFilter)
  }
}

function addFilterClasses (productSliders, sku) {
  productSliders.find('.js-product-slide').each(function () {
    const $this = $(this)
    const filterVariant = $this.data('filter-variant')
    const slideClassList = $this.parents('.slick-slide')[0].classList
    const sanitizedClassList = [...slideClassList].filter(x => !x.includes('filter-'))
    $this.parents('.slick-slide')[0].classList = sanitizedClassList.join(' ')

    if (filterVariant.includes('|')) {
      const sanitizedArr = filterVariant.split('|')
      const skuIndex = sanitizedArr.indexOf(sku)

      if (skuIndex > -1) {
        $this.parents('.slick-slide').addClass(`filter-${sku}`)
      }
    }
  })
}

function filterImages (productSliders, activeVariantFilter) {
  productSliders.slick('slickFilter', function () {
    return $(this).attr('class') === activeVariantFilter
  })

  reIndexSlides(productSliders)
}

function reIndexSlides ($slick) {
  $slick.each(function() {
    const slides = $(this).find('.slick-slide:not(.slick-cloned)')

    slides.each(function (index, slide) {
      $(slide).attr('data-slick-index', index)
    })
  })

  $slick.slick('slickGoTo', 0, true)
}

$('.js-product-slide-thumb').on('click', function(){
  const parent = $(this).parents('.slick-slide');

  index = parent.data('slick-index')
  slickObj = $('.js-product-sliders-main').slick('getSlick')

  slickObj.slickGoTo(index, true)
})

function initializeSliders (sliderClass1, sliderClass2) {
  const slider1 = $(sliderClass1)
  const slider2 = $(sliderClass2)

  slider1.find('img').wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
    touch: false,
    magnify: 1
  });

  slider1.slick({
    initialSlide: 0,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: slider2,
    infinite: true,
    adaptiveHeight: true
  })

  slider2.slick({
    asNavFor: slider1,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false
  })
}

initializeSliders('.js-product-sliders-main', '.js-product-sliders-thumbnails')

window.addEventListener('DOMContentLoaded', (event) => {
  const loginCheckoutInput = document.querySelector('.js-checkout-primary-login');
  const btnHidden = document.querySelector('.js-hidden-submit-btn')

  if(loginCheckoutInput){
    setTimeout(() => {
      btnHidden.classList.remove('hidden')
    }, 8000);
  }
});

const $giftMessageFields = $('.js-gift-message-fields');

if ($giftMessageFields) {
  const $successMessage = $giftMessageFields.find('.js-success-message');
  let typingTimer;

  /**
   * Check if all inputs are populated
   *
   * @return {Boolean}
   */
  function checkIfAllInputsArePopulated() {
    let allAreValid = true;

    $giftMessageFields.find('input, textarea').each(function() {
      if (!$(this).val()) {
        allAreValid = false;
      }
    })

    return allAreValid;
  }

  $giftMessageFields.find('input, textarea').each(function() {
    const $this = $(this);

    $this.on('keyup', function() {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        if (checkIfAllInputsArePopulated()) {
          $successMessage.addClass('is-active');
          return;
        }

        $successMessage.removeClass('is-active');
      }, 1500);
    })

    $this.on('keydown', function() {
      clearTimeout(typingTimer);
    })
  })
}

// let myinput = document.querySelector('textarea#gift-message');



function removeInvalidChars() {
  var myinput = document.querySelector('textarea#gift-message');
  var output = document.querySelector('textarea#gift-message');
  var str = myinput.value;
  

  str = str.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');

  //str = str.replace(/./,"");

  //str = str.replace(/[^\w\.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~\s]*/g,"")
  console.log(str);
  console.log(str.length);

  jQuery(myinput).val(str);

  // myinput.value = str;
}

// jQuery(document).on('change', 'textarea#gift-message', function() {    
//   var myinput = jQuery('.gift_message_toggle.gift_msg_toggled_off textarea#gift-message').val();
//   myinput =  myinput.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');
//   jQuery('.gift_message_toggle textarea#gift-message').val(myinput);
//   jQuery('.gift_message_toggle textarea#gift-message').text(myinput);
//   console.log(myinput);
// });




// $(document).ready(function(){
//   $('.gift_message_toggle.gift_msg_toggled_off textarea#gift-message').on('input', function(){
//     var longitudTexto = $(this).val().length;
//     console.log('escribiendo');
//   });
// });

$(document).on('input', '.gift_message_toggle.gift_msg_toggled_off textarea#gift-message', function() {
    var myinput = $(this).val();
    myinput =  myinput.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');
    jQuery('.gift_message_toggle textarea#gift-message').val(myinput);
    jQuery('.gift_message_toggle textarea#gift-message').text(myinput);
    console.log(myinput);
});

jQuery(document).on('change', 'input#gift_toggle', function() {      
    
    console.log('M change');
    if ($(this).is(':checked')) {
      
       /**  price product */
       $("div#theme-ajax-cart .ajax-cart__price.price").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisible');
          var itemCreate = parent.find('.isVisible');
          console.log(itemCreate);
          itemCreate.removeAttr('data-limoniapps-discountninja-cart-key');
          itemCreate.removeClass('ajax-cart__price price limoniapps-discountninja-cart-item-product-price');
          var recuperdPrice = itemCreate.find('.limoniapps-discountninja-productprice-replaced span.money.limoniapps-discountninja-money.geolizr-currency span.money').text();
         console.log(recuperdPrice);
          if(recuperdPrice != ''){
          	$('div#ajax-cart__content').addClass('custom__class_gp');
          }else{
            $('div#ajax-cart__content').addClass('custom__class_gp custom__class__normal_gp');
            parent.addClass('defaul__price');
          }
          itemCreate.find('span:first-child').text(recuperdPrice );
          itemCreate.find('span:first-child').removeClass('limoniapps-discountninja-cart-item-product-price' );
          itemCreate.find('span:first-child').addClass('recoveryPrice_gp' );
       });

      /**  discount porcent product */
      $("div#theme-ajax-cart .limoniapps-discountninja-cart-item-product-comment").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisiblePorcent');
          var itemCreate_p = parent.find('.isVisiblePorcent');
          console.log(itemCreate_p);
          itemCreate_p.removeAttr('data-limoniapps-discountninja-cart-key');
          itemCreate_p.removeClass('limoniapps-discountninja-cart-item-product-comment');
          itemCreate_p.find('div.limoniapps-discountninja-cart-item-product-comment').removeClass('limoniapps-discountninja-cart-item-product-comment').addClass('isVisiblePorcentContent');
          itemCreate_p.find('span.limoniapps-discountninja-productprice-replaced').removeClass('limoniapps-discountninja-productprice-replaced').addClass('isVisiblePorcentContentSpan');
     });

      /**  subtotal products */
      $("#theme-ajax-cart span.money.limoniapps-discountninja-cart-subtotal-price").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisibleSubtotal');
          $('.isVisibleSubtotal').removeClass('money limoniapps-discountninja-cart-subtotal-price');
          $('.isVisibleSubtotal').find('*').removeAttr('class');
      });
      
     $(document).on('click','span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close',function(){
         console.log('CLICK PLUS3');
         setTimeout(function() {
           /**  price product */
           $("div#theme-ajax-cart .ajax-cart__price.price").each(function(index, el) {
              var parent = $(this).parent();
              $(this).clone().appendTo(parent).addClass('isVisible');
              var itemCreate = parent.find('.isVisible');
              console.log(itemCreate);
              itemCreate.removeAttr('data-limoniapps-discountninja-cart-key');
              itemCreate.removeClass('ajax-cart__price price limoniapps-discountninja-cart-item-product-price');
              var recuperdPrice = itemCreate.find('.limoniapps-discountninja-productprice-replaced span.money.limoniapps-discountninja-money.geolizr-currency span.money').text();
              if(recuperdPrice != ''){
              	$('div#ajax-cart__content').addClass('custom__class_gp');
              }else{
                $('div#ajax-cart__content').addClass('custom__class_gp custom__class__normal_gp');
                parent.addClass('defaul__price');
              }
              itemCreate.find('span:first-child').text(recuperdPrice );
              itemCreate.find('span:first-child').removeClass('limoniapps-discountninja-cart-item-product-price' );
              itemCreate.find('span:first-child').addClass('recoveryPrice_gp' );
           });

           /**  discount porcent product */
            $("div#theme-ajax-cart .limoniapps-discountninja-cart-item-product-comment").each(function(index, el) {
                var parent = $(this).parent();
                $(this).clone().appendTo(parent).addClass('isVisiblePorcent');
                var itemCreate_p = parent.find('.isVisiblePorcent');
                console.log(itemCreate_p);
                itemCreate_p.removeAttr('data-limoniapps-discountninja-cart-key');
                itemCreate_p.removeClass('limoniapps-discountninja-cart-item-product-comment');
                itemCreate_p.find('div.limoniapps-discountninja-cart-item-product-comment').removeClass('limoniapps-discountninja-cart-item-product-comment').addClass('isVisiblePorcentContent');
                itemCreate_p.find('span.limoniapps-discountninja-productprice-replaced').removeClass('limoniapps-discountninja-productprice-replaced').addClass('isVisiblePorcentContentSpan');
           });

            /**  subtotal products */
            $("#theme-ajax-cart span.money.limoniapps-discountninja-cart-subtotal-price").each(function(index, el) {
                $('.isVisibleSubtotal').remove();
                var parent = $(this).parent();
                $(this).clone().appendTo(parent).addClass('isVisibleSubtotal');
                $('.isVisibleSubtotal').removeClass('money limoniapps-discountninja-cart-subtotal-price');
                $('.isVisibleSubtotal').find('*').removeAttr('class');
                
            });            
         }, 3000);
     });   
      
    }
});



// custom ajax cart bar
let element_exist = 0;
let intervquery = null;

function formatPrice(priceInCents) {
  let price = priceInCents / 100;
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
}

let loop_init = 0;
$(document).on('click', '.ajax-submit, span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close, li.menu__item-cart>a', function (e) {  
  loop_init = 0;
  jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').removeClass('removeblockhidden');
  intervquery = setInterval(queryCart, 1000);
});

$(document).on('change', 'div#theme-ajax-cart input.quantity-input.quantity-element.input', function (e) {  
  loop_init = 0;
  jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').removeClass('removeblockhidden');
  intervquery = setInterval(queryCart, 1000);
});


function queryCart() {
  if(loop_init <= 6) {
    loop_init++;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        console.log('El carrito tiene ' + cart.item_count + ' artículos.');
        console.log(cart);
        let originalPrice = cart.original_total_price;
        let priceWithDiscount = cart.total_price;
        let discount = cart.total_discount;
        let formattedPriceDiscount = formatPrice(priceWithDiscount);
        let formattedPriceOriginal = formatPrice(originalPrice);

        // Shopify Plus B2B catalogs report the retail/wholesale gap as
        // `cart.total_discount` (original_total_price = retail,
        // total_price = wholesale). That would trigger the discount UI
        // below and render two subtotals (wholesale + retail) after any
        // qty change. For B2B viewers, skip the injection entirely —
        // the markup's existing `<span class="money">{{ cart.total_price }}</span>`
        // already shows the correct wholesale total. Don't add any
        // `subtotal_custom_limpn` divs and don't hide the original row.
        if(document.body.classList.contains('is-b2b')){
          clearInterval(intervquery);
          return;
        }

        if(discount != 0){
          if(element_exist === 0){
            jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row .ajax-cart__row-description').after('<div class="subtotal_custom_limpn subtotal_custom_limpn_discount"><span class="discount_custom_limpn">'+formattedPriceDiscount+'</span><span class="original_custom_limpn">'+formattedPriceOriginal+'</span></div>');
            element_exist = 1;
          }else{   
            jQuery('.subtotal_custom_limpn').addClass('subtotal_custom_limpn_discount');
            jQuery('.discount_custom_limpn').text(formattedPriceDiscount);
            jQuery('.original_custom_limpn').text(formattedPriceOriginal);
          }  
          jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').addClass('removeblockhidden');
          clearInterval(intervquery);
        }else{
          console.log('no descuento');
          if(element_exist === 0){
            jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row .ajax-cart__row-description').after('<div class="subtotal_custom_limpn"><span class="discount_custom_limpn"></span><span class="original_custom_limpn">'+formattedPriceOriginal+'</span></div>');
            element_exist = 1;
          }else{            
            jQuery('.original_custom_limpn').text(formattedPriceOriginal);
          } 
          jQuery('.subtotal_custom_limpn_discount').removeClass('subtotal_custom_limpn_discount');
        }        
      },
      error: function() {
        console.log('No se pudo recuperar el carrito.');
      }
    });
  } else {
        jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').addClass('removeblockhidden');
        clearInterval(intervquery);
   }
}




// $(document).on('click','span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close',function(){
//   setInterval(function () {
//     let valueprice = 0;
//     $("body> #theme-ajax-cart .ajax-cart__product.media").each(function(index, el) {
//           var _this = $(this);
//           let price = _this.find('.ajax-cart__price.price span');
//           let value_this = price.text();

//           let originalPriceString = value_this;
//           let priceWithoutDollarSign = originalPriceString.replace("$", "");
//           let priceWithoutDot = priceWithoutDollarSign.replace(".", "");
//           let priceAsNumber = parseInt(priceWithoutDot, 10);

//           valueprice = valueprice + priceAsNumber;

//           let subtotalPrice = valueprice; // El precio en centavos
//           let formattedPrice = (subtotalPrice / 100).toFixed(2); // Convertir a unidades de moneda y fijar dos decimales

          
//           console.log(priceAsNumber); // Debería imprimir 38500
//           console.log(formattedPrice);
//           jQuery('.ajax-cart__subtotal.ajax-cart__details-row > span').text('$'+formattedPrice);
//       });
//   }, 2000);
// });




// Fix: Recharge dynamically re-renders product pricing and can cause incorrect prices,
// especially during rapid variant changes or on single-variant products.
// This solution uses the selected variant ID + product JSON as the source of truth,
// ensuring the correct price is always displayed without flicker or race conditions.

jQuery(document).ready(function(){

  let productDataPromise = null;
  let latestVariantId = null;

  function getProductJson() {
    if (!productDataPromise) {
      productDataPromise = fetch(window.location.pathname + '.js', {
        credentials: 'same-origin'
      }).then(function(res) {
        if (!res.ok) throw new Error('Failed to load product JSON');
        return res.json();
      });
    }
    return productDataPromise;
  }

  function getSelectedVariantId(product) {
    // Standard Shopify variant selector
    const mainSelector = document.querySelector('[data-variant-selector]');
    if (mainSelector && mainSelector.value) {
      return String(mainSelector.value);
    }

    // Fallback for single-variant products
    if (product && product.variants && product.variants.length === 1) {
      return String(product.variants[0].id);
    }

    return null;
  }

  function formatPriceFromCents(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function setDisplayedPrice(priceText) {
    const selectors = [
      'span.current_price.recharge-inner-most-price',
      'span.current_price.js-current-price'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.textContent.trim() !== priceText) {
          el.textContent = priceText;
          el.setAttribute('data-wholesale-forced', 'true');
        }
      });
    });
  }

  function syncWholesalePrice() {
    if (!jQuery('.product_form').hasClass('wholesaleb2b')) return;

    getProductJson().then(function(product) {

      const variantId = getSelectedVariantId(product);
      if (!variantId) return;

      latestVariantId = variantId;

      const variant = (product.variants || []).find(function(v) {
        return String(v.id) === String(latestVariantId);
      });

      if (!variant) return;

      const wholesalePrice = formatPriceFromCents(variant.price);
      setDisplayedPrice(wholesalePrice);

      console.log('SYNC WHOLESALE →', latestVariantId, wholesalePrice);

    }).catch(function(err) {
      console.log('Wholesale sync error:', err);
    });
  }

  // Initial run
  syncWholesalePrice();

  // Variant changes
  $(document).on('change', '.single-option-selector, [data-variant-selector]', function() {
    syncWholesalePrice();
  });

  // Watch for Recharge re-rendering price
  const target = document.querySelector('.product__information');
  if (target) {
    const observer = new MutationObserver(function(mutations) {

      const touchedPrice = mutations.some(function(mutation) {
        return jQuery(mutation.target).closest('.current_price').length > 0;
      });

      if (touchedPrice) {
        syncWholesalePrice();
      }

    });

    if (target && target.nodeType === Node.ELEMENT_NODE) {
      observer.observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

});


/* ── B44 Cart Page: force display fixes that beat Flex inline block ──
   Flex's inline <style> (line 7 of theme.liquid) sets:
     .container { display: flex }
   This runs after DOM ready and uses element.style (Level 3)
   which beats ALL stylesheets. Cart page only.
   ─────────────────────────────────────────────────────────────── */
(function() {
  if (!window.location.pathname.match(/^\/cart/)) return;

  function fixCartPage() {
    // 1. cost-summary: force block display so ::before eyebrow renders
    var summary = document.querySelector('.section__static-cart .cart__cost-summary');
    if (summary) {
      summary.style.setProperty('display', 'block', 'important');
    }

    // 2. column header row: force grid display at desktop
    var headings = document.querySelector('.section__static-cart .cart__headings--b44');
    if (headings && window.innerWidth >= 1024) {
      headings.style.setProperty('display', 'grid', 'important');
    }

    // 3. each cart card: force grid layout at desktop
    var cards = document.querySelectorAll('.section__static-cart #cart_form .cart__item-list .cart__card');
    cards.forEach(function(card) {
      if (window.innerWidth >= 1024) {
        card.style.setProperty('display', 'grid', 'important');
        card.style.setProperty('grid-template-columns', '80px 1fr', 'important');
        card.style.setProperty('gap', '0 1rem', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCartPage);
  } else {
    fixCartPage();
  }

  // Re-run on resize in case of orientation change
  window.addEventListener('resize', fixCartPage);
})();

/* ── B44 Cart: fix ORDER SUMMARY column offset + gift toggle ───────────
   Flex CDN stylesheet sets .eight { width: calc(66%-20px) } and
   .offset-by-eight { margin-left: 33% } — can't be overridden from
   our stylesheets because CDN loads last. Force via inline style.
   ─────────────────────────────────────────────────────────────────── */
(function() {
  if (!window.location.pathname.match(/^\/cart/)) return;

  function fixCartDOM() {
    try {
      // Fix .eight.offset-by-eight column inside cost-summary
      var cols = document.querySelectorAll('.section__static-cart .cart__cost-summary .column, .section__static-cart .cart__cost-summary .eight');
      cols.forEach(function(col) {
        col.style.setProperty('width', '100%', 'important');
        col.style.setProperty('max-width', '100%', 'important');
        col.style.setProperty('margin-left', '0', 'important');
        col.style.setProperty('margin-right', '0', 'important');
        col.style.setProperty('padding-left', '0', 'important');
        col.style.setProperty('padding-right', '0', 'important');
        col.style.setProperty('float', 'none', 'important');
      });

      // Switch to position:absolute layout — CSS grid row-height pollution from sidebar
      // made cards start at sidebar.offsetHeight. Absolute sidebar + block itemList is reliable.
      var itemList = document.querySelector('.section__static-cart .cart__item-list');
      var sidebar = document.querySelector('.section__static-cart .cart__item-list > .b44-sidebar-col');
      if (itemList && sidebar) {
        if (window.innerWidth >= 1024) {
          // Desktop: 2-col grid — products left, sticky Order Summary right.
          // (Applied inline so it survives Discount Ninja's cart re-renders.)
          itemList.style.setProperty('display', 'grid', 'important');
          itemList.style.setProperty('grid-template-columns', 'minmax(0, 1fr) 320px', 'important');
          itemList.style.setProperty('column-gap', '44px', 'important');
          itemList.style.setProperty('align-items', 'start', 'important');
          itemList.style.setProperty('position', 'static', 'important');
          itemList.style.setProperty('padding-right', '0', 'important');
          itemList.style.setProperty('box-sizing', 'border-box', 'important');
          itemList.style.setProperty('width', '100%', 'important');
          itemList.style.setProperty('margin-left', '0', 'important');
          itemList.style.setProperty('margin-right', '0', 'important');
          sidebar.style.setProperty('grid-column', '2', 'important');
          sidebar.style.setProperty('grid-row', '1 / 999', 'important');
          sidebar.style.setProperty('align-self', 'start', 'important');
          sidebar.style.setProperty('position', 'sticky', 'important');
          sidebar.style.setProperty('top', '120px', 'important');
          sidebar.style.removeProperty('right');
          sidebar.style.setProperty('width', '320px', 'important');
          sidebar.style.setProperty('display', 'block', 'important');
          sidebar.style.setProperty('order', '', 'important');
          sidebar.style.setProperty('margin-top', '0', 'important');
          // Undo the phone-only padding if the window was resized up
          var deskSection = document.querySelector('.section__static-cart');
          var deskRoot = document.querySelector('.section__static-cart .limoniapps-discountninja-cart-root');
          if (deskSection) { deskSection.style.removeProperty('padding-left'); deskSection.style.removeProperty('padding-right'); }
          if (deskRoot) { deskRoot.style.removeProperty('padding-left'); deskRoot.style.removeProperty('padding-right'); }

        } else {
          // Mobile: flex column, sidebar stacks below items.
          // Clear desktop-only grid/sticky props so resizing across the
          // breakpoint doesn't leave stale inline state (caused layout weirdness).
          itemList.style.setProperty('display', 'flex', 'important');
          itemList.style.setProperty('flex-direction', 'column', 'important');
          itemList.style.setProperty('position', 'static', 'important');
          itemList.style.setProperty('padding-right', '0', 'important');
          itemList.style.removeProperty('grid-template-columns');
          itemList.style.removeProperty('column-gap');
          itemList.style.removeProperty('align-items');
          sidebar.style.setProperty('position', 'static', 'important');
          sidebar.style.setProperty('width', '100%', 'important');
          sidebar.style.setProperty('order', '99', 'important');
          sidebar.style.setProperty('margin-top', '2rem', 'important');
          sidebar.style.removeProperty('grid-column');
          sidebar.style.removeProperty('grid-row');
          sidebar.style.removeProperty('align-self');
          sidebar.style.removeProperty('top');
          // Section padding (30px) plus the Discount Ninja container's own
          // padding (45px) left the cart in a 240px column on phones.
          var cartSection = document.querySelector('.section__static-cart');
          var cartRoot = document.querySelector('.section__static-cart .limoniapps-discountninja-cart-root');
          if (cartSection) {
            cartSection.style.setProperty('padding-left', '16px', 'important');
            cartSection.style.setProperty('padding-right', '16px', 'important');
          }
          if (cartRoot) {
            cartRoot.style.setProperty('padding-left', '0', 'important');
            cartRoot.style.setProperty('padding-right', '0', 'important');
          }
          itemList.style.setProperty('width', '100%', 'important');
          itemList.style.setProperty('margin-left', '0', 'important');
          itemList.style.setProperty('margin-right', '0', 'important');
        }
      }


      // Fix DN cart root container padding-top
      var dnRoot = document.querySelector('.section__static-cart .limoniapps-discountninja-cart-root');
      if (dnRoot) {
        dnRoot.style.setProperty('padding-top', '0', 'important');
        dnRoot.style.setProperty('margin-top', '0', 'important');
      }

      // Wire gift toggle checkbox
      var cb = document.getElementById('gift_toggle_static2');
      var fields = document.getElementById('b44-gift-fields');
      if (cb && fields && !cb._b44wired) {
        cb._b44wired = true;
        cb.addEventListener('change', function() {
          fields.style.display = this.checked ? 'block' : 'none';
        });
      }
    } catch(e) {
      // silent
    }
  }

  // Retry cascade: 0ms, 300ms, 800ms, 1500ms, 3000ms
  // Discount Ninja can inject/modify DOM well after DOMContentLoaded
  var _b44RetryCount = 0;
  var _b44RetryDelays = [0, 300, 800, 1500, 3000];

  function runWithRetries() {
    fixCartDOM();
    _b44RetryCount++;
    if (_b44RetryCount < _b44RetryDelays.length) {
      setTimeout(runWithRetries, _b44RetryDelays[_b44RetryCount]);
    }
  }

  // MutationObserver: re-run if DN modifies cart__item-list or its children
  function observeCartDOM() {
    var itemList = document.querySelector('.section__static-cart .cart__item-list');
    if (!itemList) return;
    var observer = new MutationObserver(function(mutations) {
      var needsRefix = mutations.some(function(m) {
        // Re-run if attributes (like style) change on itemList or b44-sidebar-col
        return m.type === 'attributes' || m.type === 'childList';
      });
      if (needsRefix) {
        // Debounce: don't hammer if many mutations arrive at once
        clearTimeout(window._b44FixDebounce);
        window._b44FixDebounce = setTimeout(fixCartDOM, 50);
      }
    });
    observer.observe(itemList, {
      attributes: true,
      childList: true,
      subtree: false
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    runWithRetries();
    // Start observer after brief delay to let DN set up first
    setTimeout(observeCartDOM, 500);
    // Re-apply the correct layout when the viewport crosses the 1024px
    // breakpoint on resize — otherwise the inline styles set at load stay at
    // the old breakpoint's values and the layout breaks on resize.
    window.addEventListener('resize', function() {
      clearTimeout(window._b44ResizeDebounce);
      window._b44ResizeDebounce = setTimeout(fixCartDOM, 100);
    });
  });
})();

/* ── Bloom wine shipping terms: show when cart contains wine with ABV ──
   bloom-abv-checkout-condition Liquid snippet uses old metafield API that
   doesn't resolve on current products. Use Bloom's JS storefront data instead. */
(function() {
  function checkBloomWineWithCart(callback) {
    // Use /cart.js for reliable variant IDs regardless of DOM state
    var bloomData = window.Bloom && window.Bloom.storefront && window.Bloom.storefront.data && window.Bloom.storefront.data.products;
    if (!bloomData) { callback(false); return; }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
        var hasWine = bloomData.some(function(product) {
          if (!product.abv && product.abv !== 0) return false;
          if (!product.variants || !product.variants.length) return false;
          return product.variants.some(function(variant) {
            return cartVariantIds.indexOf(String(variant.id)) !== -1;
          });
        });
        callback(hasWine);
      })
      .catch(function() { callback(false); });
  }

  function updateBloomWidget() {
    checkBloomWineWithCart(function(hasWine) {
      // Full cart page sidebar widget
      var wrapper = document.querySelector('.section__static-cart .b44-bloom-wrapper');
      if (wrapper) wrapper.style.display = hasWine ? 'block' : 'none';
      // Drawer cart datepicker
      var drawerWrapper = document.querySelector('#theme-ajax-cart .b44-drawer-bloom-wrapper');
      if (drawerWrapper) drawerWrapper.style.display = hasWine ? 'block' : 'none';
    });
  }

  // Expose globally so the patch can reference it across scopes
  window._updateBloomWidget = updateBloomWidget;

  // Patch updateView to re-run Bloom check after drawer re-renders
  function patchUpdateView() {
    if (Shopify && Shopify.theme && Shopify.theme.jsAjaxCart && Shopify.theme.jsAjaxCart.updateView) {
      if (!Shopify.theme.jsAjaxCart._bloomPatched) {
        var orig = Shopify.theme.jsAjaxCart.updateView.bind(Shopify.theme.jsAjaxCart);
        Shopify.theme.jsAjaxCart.updateView = function() {
          orig.apply(this, arguments);
          setTimeout(window._updateBloomWidget, 600);
        };
        Shopify.theme.jsAjaxCart._bloomPatched = true;
      }
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Try immediately, then retry every 300ms until jsAjaxCart is ready
    if (!patchUpdateView()) {
      var interval = setInterval(function() {
        if (patchUpdateView()) clearInterval(interval);
      }, 300);
    }
    setTimeout(updateBloomWidget, 500);
    setTimeout(updateBloomWidget, 1500);
  });

  // Run when drawer cart opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-ajax-cart-trigger]')) {
      setTimeout(updateBloomWidget, 400);
      setTimeout(updateBloomWidget, 1000);
    }
  });

  // Run after cart view updates
  document.addEventListener('cart:updated', function() {
    setTimeout(updateBloomWidget, 300);
  });

  // Run after DN refreshes drawer cart
  document.addEventListener('limoniapps:discountninja:drawercart:refreshed', function() {
    setTimeout(updateBloomWidget, 300);
  });

  // Watch DN placeholder in drawer — if empty after cart opens, inject fallback input
  function ensureDrawerDiscountField() {
    var placeholder = document.querySelector('#theme-ajax-cart .limoniapps-discountninja-cartdiscountfield-placeholder');
    if (!placeholder) return;
    if (placeholder.children.length > 0) return; // DN already injected

    // DN hasn't injected — check again after a delay, then show fallback
    setTimeout(function() {
      if (placeholder.children.length > 0) return;
      // Build a minimal discount field that submits to DN's endpoint
      placeholder.innerHTML = [
        '<div style="display:flex;gap:0">',
        '<input type="text" class="limoniapps-discountninja-cartdiscountfield-input"',
        ' placeholder="Enter discount code"',
        ' style="flex:1;border:1px solid #d8d3cb;padding:0.5rem 0.75rem;',
        'font-family:Palatino,Georgia,serif;font-size:0.75rem;color:#1A302B;background:#fff">',
        '<button class="limoniapps-discountninja-cartdiscountfield-apply"',
        ' style="background:#f7f5f2;border:1px solid #d8d3cb;color:rgba(26,48,43,0.6);',
        'font-family:Montserrat,sans-serif;font-size:9px;letter-spacing:0.2em;',
        'text-transform:uppercase;padding:0.5rem 0.75rem;cursor:pointer;white-space:nowrap">APPLY</button>',
        '</div>'
      ].join('');
    }, 1500);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-ajax-cart-trigger]')) {
      setTimeout(ensureDrawerDiscountField, 600);
    }
  });
})();

/* ──────────────────────────────────────────────────────────────────────────
   B44 header cart-count badge visibility
   --------------------------------------------------------------------------
   The b44 header badges (.base44-cart-count) now carry data-bind="itemCount"
   so Flex's cart JS (z__jsAjaxCart.js / z__jsCart.js) updates their text via
   its own $('[data-bind="itemCount"]').text(cart.item_count) call. That
   handles the number. What's left: hide the badge at zero and show it again
   when the cart repopulates — the Liquid render sets `hidden` initially, but
   Flex's .text() only updates the number, never the attribute.

   A MutationObserver on each badge toggles `hidden` whenever the text changes.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  function toggleHidden(badge) {
    var n = parseInt((badge.textContent || '').replace(/[^\d]/g, ''), 10);
    badge.hidden = !(n > 0);
  }

  function init() {
    var badges = document.querySelectorAll('.base44-cart-count');
    if (!badges.length) return;
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) {
        var badge = r.target.closest ? r.target.closest('.base44-cart-count') : null;
        if (badge) toggleHidden(badge);
      });
    });
    badges.forEach(function (badge) {
      mo.observe(badge, { childList: true, characterData: true, subtree: true });
      toggleHidden(badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Normalize Discount Ninja's cart savings text ─────────────────────────────
   DN injects the savings line as literal message text, e.g. "🎁 YOU SAVE -$2.25".
   None of this is changeable via CSS (emoji + caps + minus are baked into the
   text) or via DN settings without editing every promo, so we rewrite the
   rendered text nodes:
     • strip the gift emoji (🎁)
     • re-case "YOU SAVE" → "You Save" (CSS text-transform can't lowercase)
     • drop the minus before the amount ("-$2.25" → "$2.25") — it's a saving,
       the minus reads as confusing
   Runs on load, synchronously inside a MutationObserver (DN re-renders the cart),
   and on DN's own refresh events. Only touches text nodes inside cart savings
   elements, so DN's structure (amount span, etc.) is preserved. Covers both the
   drawer ([data-la-dn-cart-item-text]) and the main cart
   (.limoniapps-discountninja-cart-item-product-comment). */
(function () {
  var GIFT = '🎁'; // gift-wrapped present emoji
  var SELECTOR = '[data-la-dn-cart-item-text], .limoniapps-discountninja-cart-item-product-comment, .limoniapps-discountninja-subtotalcomment-summary-row';
  function strip() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // DN renders the saved amount as a negative ("-$2.25"). We drop that minus
      // for readability, but only when this savings element actually shows a
      // currency amount — so a stray "-" elsewhere is never touched.
      var hasCurrency = /[$£€]/.test(el.textContent || '');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        var v = n.nodeValue, orig = v;
        if (v.indexOf(GIFT) !== -1) {
          v = v.split(GIFT).join('');
        }
        // "YOU SAVE" / "YOU SAVED" → "You Save" / "You Saved" (any casing)
        v = v.replace(/YOU\s+SAVE(D)?/gi, function (m, d) { return 'You Save' + (d ? 'd' : ''); });
        // drop the minus before a currency amount in the SAME node ("-$2.25" → "$2.25")
        v = v.replace(/-\s*(?=[$£€])/g, '');
        // …and the common case where DN puts the minus in its OWN text node,
        // separate from the amount node ("You Save " + "-" + "$2.25").
        if (hasCurrency && /^\s*-\s*$/.test(v)) {
          v = '';
        }
        if (v !== orig) { n.nodeValue = v.replace(/^\s+/, ''); }
      }
    }
  }
  function init() {
    strip();
    // Strip SYNCHRONOUSLY in the observer callback (no setTimeout). Observer
    // callbacks run as microtasks — before the browser paints — so DN's freshly
    // injected emoji is removed before it's ever visible. A debounce here let it
    // paint first, causing it to flicker once per DN re-render (~7-8 times).
    // We watch childList only (not characterData), so our nodeValue edits don't
    // retrigger the observer; the cart-scoped selector keeps strip() cheap.
    var obs = new MutationObserver(strip);
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { setTimeout(strip, 50); });
    document.addEventListener('limoniapps:discountninja:drawercart:refreshed', function () { setTimeout(strip, 50); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Wine age-gate checkout enable/disable (redesign-robust) ──────────────────
   The legacy validators (cart.ajax.liquid / cart__main.liquid) were written for
   the old Flex markup: they scoped to `.header__spacer` (gone in the redesign)
   and `.month/.day/.year.date-selection` (Bloom now renders plain `.date-selection`),
   and the main-cart one targeted `.cart__checkout button.add_to_cart` (the button
   isn't inside `.cart__checkout`). Net result: wine carts could never re-enable
   checkout. This authoritative gate reads Bloom's actual visible date widget per
   cart and toggles the real `button[name="checkout"]`. It overrides the legacy
   function names so their existing listeners drive correct logic, and re-runs on
   delegated change/input/click + on cart re-render, so it survives Bloom/ajax
   re-renders. A cart with no visible DOB widget (non-wine) is never blocked. */
(function () {
  // Compute whether the selected DOB is at least minAge. The 3 Bloom selects carry
  // no month/day/year class, so identify them by option count: year has the most
  // options, then day, then month. Returns false on any incomplete/unparseable value
  // (fail closed — never enable wine checkout on an uncertain age).
  function mrDobIsOfAge(sels, minAge) {
    if (sels.length < 3) return false;
    var ranked = sels.map(function (s) {
      var n = 0, opts = s.options;
      for (var i = 0; i < opts.length; i++) { if (opts[i].value !== '') n++; }
      return { v: parseInt(s.value, 10), n: n };
    });
    for (var j = 0; j < ranked.length; j++) { if (!ranked[j].v || isNaN(ranked[j].v)) return false; }
    ranked.sort(function (a, b) { return b.n - a.n; }); // [year, day, month]
    var year = ranked[0].v, day = ranked[1].v, month = ranked[2].v;
    if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) return false;
    var now = new Date();
    var age = now.getFullYear() - year;
    if ((now.getMonth() + 1) < month || ((now.getMonth() + 1) === month && now.getDate() < day)) age--;
    return age >= minAge;
  }
  function gateContainer(root) {
    if (!root) return;
    var btns = root.querySelectorAll('button[name="checkout"]');
    if (!btns.length) return;
    // Only visible date selects count: when there is no wine, the widget is hidden.
    var sels = Array.prototype.filter.call(
      root.querySelectorAll('.date-selection'),
      function (s) { return s.offsetParent !== null; }
    );
    var ship = root.querySelector('#ship_agreement');
    var shipVisible = !!(ship && ship.offsetParent !== null);
    var enable;
    if (sels.length === 0 && !shipVisible) {
      enable = true; // no active age gate in this cart (non-wine)
    } else {
      var placeholders = ['', 'Month', 'Day', 'Year'];
      var dobComplete = sels.length >= 3 && sels.every(function (s) {
        return placeholders.indexOf((s.value || '').trim()) === -1;
      });
      // Compliance: the DOB must be filled AND >= 21, plus the CA ship agreement.
      enable = dobComplete && mrDobIsOfAge(sels, 21) && (shipVisible ? !!ship.checked : true);
    }
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('disabled_add_btn', !enable);
    }
  }
  function mrWineGate() {
    gateContainer(document.querySelector('#theme-ajax-cart'));
    gateContainer(document.querySelector('.section__static-cart'));
  }
  function override() {
    window.validateIfCanRemoveCheckout = mrWineGate;
    window.staticValidateIfCanRemoveCheckout = mrWineGate;
  }
  override();
  function onInteract(e) {
    var t = e.target;
    if (t && ((t.classList && t.classList.contains('date-selection')) || t.id === 'ship_agreement')) {
      mrWineGate();
      setTimeout(mrWineGate, 70); // beat any legacy setTimeout that wrongly re-enables
    }
  }
  ['change', 'input', 'click'].forEach(function (ev) {
    document.addEventListener(ev, onInteract, true);
  });
  var raf;
  var obs = new MutationObserver(function () {
    override();
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(mrWineGate);
  });
  function start() {
    override();
    mrWineGate();
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { override(); mrWineGate(); });
})();

/* ── Variant Description app: sync [name="id"] on variant change (Base44 PDP) ──
   The app renders its description (and parses any [accordion] shortcodes into the
   visible accordions) by watching the variant via [name="id"]/?variant=. The Base44
   PDP never updates [name="id"] on a pill switch — it only updates the ATC button's
   data-variant-id — so the app stayed on the initial variant (e.g. the "Scent"
   accordion kept showing Verde). This mirrors the selected variant into [name="id"]
   (with input+change) so the app re-renders the correct variant's copy + accordions.
   It also keeps any other [name="id"]-based integration (e.g. ReCharge) in sync.
   Gated to PDPs where the app is present, so [name="id"] isn't touched elsewhere. */
(function () {
  function currentVariantId() {
    var src = document.querySelector('.b44-pdp__atc-btn[data-variant-id]')
           || document.querySelector('.b44-pdp__pill.is-active[data-variant-id]');
    return src ? src.getAttribute('data-variant-id') : null;
  }
  function setNativeValue(el, val) {
    if (el.value === val) return;
    var d = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), 'value');
    (d && d.set ? d.set : function (v) { el.value = v; }).call(el, val);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function syncVariantId() {
    if (!document.querySelector('[data-variant-description-app]')) return; // app not on this PDP
    var vid = currentVariantId();
    if (!vid) return;
    Array.prototype.forEach.call(document.querySelectorAll('[name="id"]'), function (inp) {
      setNativeValue(inp, vid);
    });
  }
  function init() {
    var atc = document.querySelector('.b44-pdp__atc-btn[data-variant-id]');
    if (!atc || !document.querySelector('[data-variant-description-app]')) return;
    new MutationObserver(syncVariantId).observe(atc, { attributes: true, attributeFilter: ['data-variant-id'] });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.b44-pdp__pill')) {
        setTimeout(syncVariantId, 0);
        setTimeout(syncVariantId, 150);
      }
    }, true);
    syncVariantId();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ──────────────────────────────────────────────────────────────────────────
   Ship-by date banner (.b44-ship-banner)
   --------------------------------------------------------------------------
   Rendered on the full cart page (sections/cart__main.liquid) AND the drawer
   template (templates/cart.ajax.liquid). The banner element ships `hidden`;
   this JS fills in a ship-by date and unhides it. If the JS never runs the
   banner stays hidden, which is the safe failure.

   WHY THIS IS A DATE AND NOT A COUNTDOWN
   Until 2026-08-10 this showed "Order in the next Xh Ym to ship today" off a
   2pm PT cutoff. Two things were wrong with that:

   1. It was not true. Measured against 4,581 fulfilled Online Store orders
      (Shopify Admin API, 2026-02-01 to 2026-08-10, POS and wholesale excluded),
      only 12.7% of the orders that saw that banner actually shipped the same
      business day. Same-business-day dispatch is 5.9% of web orders overall.
   2. The urgency mechanic cannot work here. The warehouse prints the day's
      pick list at open, covering everything received since the previous
      morning through 6:00am PT (Sherry Paragee, Director of Warehouse
      Operations, 2026-08-05). Against a 6am cutoff the median shopper would
      see roughly 17 hours on the clock and only 3.4% of orders would ever see
      under two hours. A countdown that never runs down is not urgency, it
      just advertises that there is no deadline.

   A specific ship-by date is true every hour of the week, survives Friday
   afternoon and the December peak, and is the thing shoppers actually want.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  /* Orders received at or after this hour PT miss that morning's pick list and
     wait for the next working day. Per Sherry Paragee, 2026-08-05. */
  var CUTOFF_HOUR_PT = 6;

  /* Working days added on top of the earliest possible dispatch, so the orders
     that slip still land inside the promise. Julia Luna (2026-08-10) puts the
     contractual window at "up to 3 days".

     Calibrated by replaying this exact rule over real fulfilment history and
     asking how often the date it would have shown was actually met:
         buffer 0 -> promise kept 89.2% (Feb-Aug), 87.5% (holiday peak)
         buffer 1 -> promise kept 94.3% (Feb-Aug), 93.1% (holiday peak)
         buffer 2 -> promise kept 95.2% (Feb-Aug), 94.6% (holiday peak)

     Set to 0 on Tom's call 2026-08-10, to state the next working day plainly
     rather than hedge a day past it. That matches what Alix committed to
     ("next day is the best we can ask for right now") and costs accuracy:
     233 more orders per six months, about 1.2 a day, ship later than the date
     shown, typically by 2 days. Raise to 1 to buy that back. */
  var BUFFER_BIZ_DAYS = 0;

  /* Days the Petaluma warehouse does not pick. Federal holidays McEvoy is
     known to observe, with Saturday holidays rolled back to the observed
     Friday. UNCONFIRMED: McEvoy has not published a warehouse closure
     calendar, so this needs a sign-off from Alix before the December peak,
     and a top-up each year. A missing entry overstates the ship date by a
     day; a spurious entry understates it, which is the safer direction. */
  var CLOSED = {
    '2026-09-07': 1, '2026-11-26': 1, '2026-11-27': 1, '2026-12-25': 1,
    '2027-01-01': 1, '2027-05-31': 1, '2027-07-05': 1, '2027-09-06': 1,
    '2027-11-25': 1, '2027-11-26': 1, '2027-12-24': 1
  };

  /* Calendar maths runs on UTC-midnight anchors so adding days can never be
     knocked sideways by a PT daylight-saving transition.

     Two formats because the phrasing changes with distance. Next-day gets the
     short weekday behind a "Tomorrow" lead ("Tomorrow, Tue, Aug 11"); anything
     further out names the day in full and drops the lead ("Monday, Aug 17"),
     which is what a Friday, Saturday or Sunday shopper needs to see. */
  var FMT_SHORT = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
  });
  var FMT_LONG = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric'
  });

  function ptNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', hour12: false
    }).formatToParts(new Date());
    var g = {};
    parts.forEach(function (p) { if (p.type !== 'literal') g[p.type] = p.value; });
    return {
      y: parseInt(g.year, 10),
      m: parseInt(g.month, 10),
      d: parseInt(g.day, 10),
      hour: parseInt(g.hour, 10) % 24
    };
  }

  function key(ms) {
    var dt = new Date(ms);
    var mm = dt.getUTCMonth() + 1;
    var dd = dt.getUTCDate();
    return dt.getUTCFullYear() + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
  }

  function isWorkingDay(ms) {
    var dow = new Date(ms).getUTCDay();
    return dow >= 1 && dow <= 5 && !CLOSED[key(ms)];
  }

  function nextWorkingDay(ms) {
    do { ms += 86400000; } while (!isWorkingDay(ms));
    return ms;
  }

  function shipDate() {
    var pt = ptNow();
    var today = Date.UTC(pt.y, pt.m - 1, pt.d);
    /* Before the cutoff on a working day the order makes this morning's pick
       list. Everything else, including all weekend traffic, starts from the
       next working day. */
    var ms = (pt.hour < CUTOFF_HOUR_PT && isWorkingDay(today)) ? today : nextWorkingDay(today);
    for (var i = 0; i < BUFFER_BIZ_DAYS; i++) ms = nextWorkingDay(ms);
    return { today: today, ship: ms, dow: new Date(today).getUTCDay() };
  }

  function sentence() {
    var s = shipDate();
    var delta = Math.round((s.ship - s.today) / 86400000);
    /* Pre-cutoff orders, about 5% of the total, really do go out the same day. */
    if (delta === 0) return 'Order now and it ships <strong>today</strong>.';
    /* "Tomorrow" only Monday through Thursday. On a Friday, Saturday or Sunday
       the next working day is Monday, and naming the day beats a relative word
       that would either be wrong (Fri, Sat) or bury the weekend gap (Sun). */
    if (delta === 1 && s.dow >= 1 && s.dow <= 4) {
      return 'Order today and it ships <strong>Tomorrow, ' + FMT_SHORT.format(new Date(s.ship)) + '</strong>.';
    }
    return 'Order today and it ships <strong>' + FMT_LONG.format(new Date(s.ship)) + '</strong>.';
  }

  function render() {
    var banners = document.querySelectorAll('.b44-ship-banner');
    if (!banners.length) return;
    var html = sentence();
    banners.forEach(function (b) {
      var textEl = b.querySelector('.b44-ship-banner__text');
      if (!textEl) return;
      /* Guard the write: the drawer re-renders on every cart change and this
         string only moves at midnight and at 6am. */
      if (textEl.innerHTML !== html) textEl.innerHTML = html;
      if (b.hidden) b.hidden = false;
    });
  }

  /* The drawer injects its banner long after load, so watch for it rather than
     polling every second the way the countdown had to. Coalesced because one
     cart change fires a burst of mutations.

     Deliberately setTimeout and not requestAnimationFrame: rAF is suspended
     outright in a hidden tab, and a shopper leaving the cart open in a
     background tab is ordinary behaviour. With rAF the drawer banner stayed
     blank until the 60s sweep, and the in-flight flag latched on so every
     later mutation was swallowed too. setTimeout is throttled in background
     tabs but still fires. Verified on the live cart 2026-08-10. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; render(); }, 0);
  }

  render();
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true, subtree: true
    });
  }
  /* Rolls the date over for a tab left open across midnight or the 6am cutoff. */
  setInterval(render, 60000);
})();


/* ------------------------------------------------------------------
 * Cart drawer: Subscribe & Save link (2026-10-27)
 * The button is rendered by templates/cart.ajax.liquid on one-time lines
 * that have a selling plan. Switch the line to that plan in place, then
 * re-render the drawer with the theme's own updateView().
 * ------------------------------------------------------------------ */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-b44-subscribe]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Subscribing...';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: btn.getAttribute('data-line-key'),
        quantity: parseInt(btn.getAttribute('data-qty'), 10) || 1,
        selling_plan: parseInt(btn.getAttribute('data-selling-plan'), 10)
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change ' + r.status);
      return r.json();
    }).then(function (cart) {
      if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart && Shopify.theme.jsAjaxCart.updateView) {
        Shopify.theme.jsAjaxCart.updateView();
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function (err) {
      console.error('Subscribe & Save failed', err);
      btn.disabled = false;
      btn.textContent = label;
    });
  });
})();

/* Cart drawer: frequency picker on subscription lines. An empty value switches
   the line back to a one-time purchase (selling_plan: null). */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-b44-frequency]');
    if (!sel) return;
    sel.disabled = true;
    var plan = sel.value ? parseInt(sel.value, 10) : null;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: sel.getAttribute('data-line-key'),
        quantity: parseInt(sel.getAttribute('data-qty'), 10) || 1,
        selling_plan: plan
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change ' + r.status);
      return r.json();
    }).then(function (cart) {
      if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart && Shopify.theme.jsAjaxCart.updateView) {
        Shopify.theme.jsAjaxCart.updateView();
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function (err) {
      console.error('Frequency change failed', err);
      sel.disabled = false;
    });
  });
})();
